import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/lib/SiteContext";
import SiteHeader from "@/components/SiteHeader";
import Gallery from "@/pages/Gallery";
import News from "@/pages/News";
import Studio from "@/pages/Studio";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

class ErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed)
      return (
        <div className="min-h-screen grid place-items-center bg-ink text-bone px-6">
          <p className="font-meta text-xs uppercase tracking-[0.3em] text-mute">
            Something went wrong — refresh the page.
          </p>
        </div>
      );
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative">
      <div className="grain-overlay" aria-hidden="true" />
      <ErrorBoundary>
        <SiteProvider>
          <BrowserRouter>
            <ScrollToTop />
            <SiteHeader />
            <Routes>
              <Route path="/" element={<Gallery />} />
              <Route path="/news" element={<News />} />
              <Route path="/studio" element={<Studio />} />
            </Routes>
          </BrowserRouter>
        </SiteProvider>
      </ErrorBoundary>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
